import { Designations } from "../../components/shared/constants"

export const adultsDesignations = [
    Designations.FirstExtraAdult,
    Designations.SecondExtraAdult,
    Designations.ThirdExtraAdult,
    Designations.FourthExtraAdult,
]

export const childrenDesignations = [
    Designations.FirstExtraChild,
    Designations.SecondExtraChild,
    Designations.ThirdExtraChild,
    Designations.FourthExtraChild,
]

export const infantsDesignations = [
    Designations.FirstExtraInfant,
    Designations.SecondExtraInfant,
    Designations.ThirdExtraInfant,
    Designations.FourthExtraInfant,
]